export const version = "3.33";
export const domain = "https://nqapp.nurulquran.com"
